import { render } from "./VisitorParentSearchItem.vue?vue&type=template&id=65fdd09c"
import script from "./VisitorParentSearchItem.vue?vue&type=script&lang=js"
export * from "./VisitorParentSearchItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__